import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/deltamax/pc/');
export default function Comp() {
    const { useLang } = useGlobal();
    const { t } = useLang('delta_max_static');

    return (
        <div className={`${css.gsapdGroupD} gsapdGroupD2`}>
            <div className="a-msg-in a-msg-in1">
                <div className="a-img-box">
                    <EFPic name={['img_2a.webp', 'img_2a.jpg']} className="fullImgs" />
                </div>
                <div className="a-msg-box">
                    <div className="msg-line-a1">
                        {t.rich('RB_pc', {
                            line1: (child) => <div>{child}</div>,
                            line2: (child) => <div>{child}</div>,
                            line3: (child) => <div>{child}</div>,
                        })}
                    </div>
                </div>
            </div>
            <div className="a-msg-in a-msg-in2">
                <div className="a-msg-box">
                    <div className="msg-line-a1">{t('FS')}</div>
                </div>
                <div className="a-img-box">
                    <EFPic name={['img_1a.webp', 'img_1a.jpg']} className="fullImgs" />
                </div>
            </div>
        </div>
    );
}
